<div id="iframe-container">
  <iframe (load)="onLoadEvent()" #iframe id="hickory-frame" class="hickory" [src]="hickoryUrl" title="Content from Legacy App"></iframe>
  <app-loading *ngIf="isLoading" [isCircle]="false"></app-loading>
</div>